import { ReactComponent as BurgerIcon } from '@Icons/menu/burger-menu.svg';

import { BaseNameSideItem } from '../../../../../enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const MyMenuItem: MenuItem = createItem(
  BaseNameSideItem.MENU,
  BaseNameSideItem.MENU,
  <BurgerIcon />
);

export default MyMenuItem;
